"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const storage_handler_1 = require("@ebay-business-components/favorites-utils/dist/utils/browser/storage-handler");
const watch_handler_1 = require("@ebay-business-components/favorites-utils/dist/utils/browser/watch-handler");
const tracking_handler_1 = require("@ebay-business-components/favorites-utils/dist/utils/browser/tracking-handler");
const constants_1 = require("@ebay-business-components/favorites-utils/dist/constants");
const constants_2 = require("../../constants");
const browser_1 = require("../../utils/browser");
const util_1 = require("./util");
class WatchHeartCTA extends Marko.Component {
    constructor() {
        super(...arguments);
        this.busy = false;
    }
    onCreate(input) {
        const itemDetails = input.itemDetails || {};
        const itemData = itemDetails.itemData || {};
        this.watchDataProvider = input.watchDataProvider;
        this.state = {
            snackbar: { content: '', open: false, actionLinkText: '' },
            showAddToListDialog: false,
            showSkuSelector: false,
            isError: false,
            responseType: '',
            animationType: undefined,
            itemDetails,
            isWatched: itemData.isWatched || false,
            watchCount: itemData.watchCount || (() => ''),
        };
    }
    onInput(input) {
        const itemDetails = input.itemDetails || {};
        const itemData = itemDetails.itemData || {};
        this.state.itemDetails = itemDetails;
        if (typeof itemData.isWatched === 'boolean') {
            this.state.isWatched = itemData.isWatched;
        }
        if (typeof itemData.watchCount === 'function') {
            this.state.watchCount = itemData.watchCount;
        }
    }
    onMount() {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, watch_handler_1.validateWatchDataProvider)(this.watchDataProvider, (_a = this.input) === null || _a === void 0 ? void 0 : _a.enableAddToList, (_b = this.input) === null || _b === void 0 ? void 0 : _b.enableSkuSelector);
        (0, browser_1.validateLocalizedContent)((_c = this.input) === null || _c === void 0 ? void 0 : _c.enableAddToList, (_d = this.input) === null || _d === void 0 ? void 0 : _d.addToListLocalizedContent, (_e = this.input) === null || _e === void 0 ? void 0 : _e.enableSkuSelector, (_f = this.input) === null || _f === void 0 ? void 0 : _f.skuSelectorLocalizedContent);
        this.subscribeTo(document).on(constants_2.EVENTS.UPDATE_WATCH_STATUS, this.handleWatchResponse.bind(this));
        if ((_g = this.input) === null || _g === void 0 ? void 0 : _g.enableAddToList) {
            this.subscribeTo(this.el).on('contextmenu', (event) => {
                this.handleOpenAddToListDialog(event);
            });
        }
        // nudge animation
        if (this.input.animationType === 'nudge') {
            const favHeart = this.getEl('favHeart');
            const favHeartCount = this.getEl('favHeartCount');
            (0, util_1.triggerNudgeAnimation)(favHeart, favHeartCount);
            // set sessionStorage to indicate that refresh is msku related
            this.subscribeTo(document).on('reload', (event) => {
                if (event.detail.isMskuRefresh) {
                    sessionStorage.setItem('isMskuRefresh', 'true');
                }
            });
        }
    }
    handleWatchResponse(watchEventResp) {
        var _a, _b, _c, _d, _e;
        const { status, itemInfo, type } = ((_a = watchEventResp === null || watchEventResp === void 0 ? void 0 : watchEventResp.detail) === null || _a === void 0 ? void 0 : _a.watchResponse) || {};
        const isSuccessful = status === 'SUCCESS';
        const itemDetails = this.state.itemDetails;
        const itemId = (_b = itemDetails === null || itemDetails === void 0 ? void 0 : itemDetails.itemData) === null || _b === void 0 ? void 0 : _b.itemId;
        const variationId = (_c = itemDetails === null || itemDetails === void 0 ? void 0 : itemDetails.itemData) === null || _c === void 0 ? void 0 : _c.variationId;
        const isSameItem = ((_d = itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo[0]) === null || _d === void 0 ? void 0 : _d.itemId) === itemId &&
            ((_e = itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo[0]) === null || _e === void 0 ? void 0 : _e.variationId) === variationId;
        if (isSuccessful && isSameItem) {
            const watched = type === constants_2.RESPONSE_TYPES.ADD_TO_WATCH_LIST_SUCCESS;
            this.state.isWatched = watched;
            this.emit(constants_2.EVENTS.WATCH_UPDATE_HANDLER, { isWatched: watched });
        }
    }
    onSnackbarClose() {
        this.state.snackbar.open = false;
        this.state.snackbar.content = '';
        this.state.snackbar.actionLinkText = '';
        this.state.isError = false;
        this.state.responseType = '';
    }
    onHeartClick() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { itemDetails } = this.state;
            const { itemData } = itemDetails || {};
            const { isMSKU } = itemData || {};
            if (isMSKU && ((_a = this.input) === null || _a === void 0 ? void 0 : _a.enableSkuSelector)) {
                this.setState('showSkuSelector', true);
                return;
            }
            yield this.handleWatchAction();
        });
    }
    handleWatchAction(variationId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (this.busy)
                return;
            this.busy = true;
            // This is called when left click is done on heart icon
            let response = {
                redirectURL: '',
            };
            const { itemDetails, isWatched } = this.state;
            const { itemData } = itemDetails || {};
            const { addToWatchHandler, removeFromWatchHandler } = this.watchDataProvider;
            itemData.variationId = variationId || itemData.variationId;
            try {
                const isMSKUWithValidVariation = !(itemData.isMSKU &&
                    (!itemData.variationId || itemData.variationId === '-1'));
                if (!isWatched) {
                    this.emit(constants_2.EVENTS.WATCH_ACTION, Object.assign(Object.assign({}, itemDetails), { isMSKUWithValidVariation }));
                    if (!isMSKUWithValidVariation)
                        return;
                    // strobe animation
                    if (this.input.animationType === 'strobe') {
                        const favHeart = this.getEl('favHeart');
                        (0, util_1.triggerStrobeAnimation)(favHeart, {
                            onStart: () => (this.state.animationType = 'strobe'),
                            onEnd: () => (this.state.animationType = undefined),
                        });
                    }
                    this.state.isWatched = true;
                    const trackingInfo = ((_a = this.input) === null || _a === void 0 ? void 0 : _a.addToWatchTrackingData) ||
                        ((_b = this.input) === null || _b === void 0 ? void 0 : _b.trackingData);
                    trackingInfo.linkId =
                        ((_d = (_c = this.input) === null || _c === void 0 ? void 0 : _c.trackingData) === null || _d === void 0 ? void 0 : _d.linkId) || constants_2.LINKID;
                    (0, tracking_handler_1.handleTracking)(trackingInfo, itemData, constants_1.WATCH_ACTION.ADD_ACTION);
                    response = yield addToWatchHandler(itemDetails, {}, trackingInfo);
                }
                else {
                    this.emit(constants_2.EVENTS.UNWATCH_ACTION, Object.assign(Object.assign({}, itemDetails), { isMSKUWithValidVariation }));
                    if (!isMSKUWithValidVariation)
                        return;
                    this.state.isWatched = false;
                    const trackingInfo = ((_e = this.input) === null || _e === void 0 ? void 0 : _e.removeFromWatchTrackingData) ||
                        ((_f = this.input) === null || _f === void 0 ? void 0 : _f.trackingData);
                    trackingInfo.linkId =
                        ((_h = (_g = this.input) === null || _g === void 0 ? void 0 : _g.trackingData) === null || _h === void 0 ? void 0 : _h.linkId) || constants_2.LINKID;
                    (0, tracking_handler_1.handleTracking)(trackingInfo, itemData, constants_1.WATCH_ACTION.REMOVE_ACTION);
                    response = yield removeFromWatchHandler(itemDetails, {}, trackingInfo);
                }
                this.handleResponse(response);
            }
            catch (error) {
                console.error(`Error occurred while handling watch action: ${error}`);
            }
            finally {
                this.busy = false;
            }
        });
    }
    handleRedirectURL(response) {
        if (response && 'redirectURL' in response) {
            // revert the optimistic watch update before redirecting to auth
            this.state.isWatched = !this.state.isWatched;
            return this.emit(constants_2.EVENTS.WATCH_UPDATE_HANDLER, {
                redirectURL: response.redirectURL,
            });
        }
    }
    handleResponse(response) {
        var _a, _b;
        if (response && 'redirectURL' in response) {
            // revert the optimistic watch update before redirecting to auth
            this.state.isWatched = !this.state.isWatched;
            this.emit(constants_2.EVENTS.WATCH_UPDATE_HANDLER, {
                redirectURL: response.redirectURL,
            });
        }
        else {
            const { status = 'ERROR', type = '', message = '', additionalMessage = '', } = response;
            if (status !== 'SUCCESS') {
                this.state.isWatched = !this.state.isWatched;
                this.state.animationType = undefined;
                if (message) {
                    this.state.snackbar.content = message;
                }
                else {
                    this.state.snackbar.content =
                        ((_b = (_a = this.input) === null || _a === void 0 ? void 0 : _a.localizedContent) === null || _b === void 0 ? void 0 : _b.error) || constants_2.MESSAGES.ERROR;
                }
                this.state.isError = true;
                this.state.snackbar.open = true;
                if (type === constants_2.RESPONSE_TYPES.CSRF_TOKEN_ERROR ||
                    type === constants_2.RESPONSE_TYPES.WATCH_LIST_FULL) {
                    this.state.snackbar.actionLinkText = additionalMessage;
                }
            }
            this.emit(constants_2.EVENTS.WATCH_UPDATE_HANDLER, Object.assign(Object.assign({ isWatched: this.state.isWatched }, (response && response.listId
                ? { listId: response.listId }
                : {})), (response && response.listName
                ? { listName: response.listName }
                : {})));
            if ((0, storage_handler_1.getSessionData)(constants_2.SESSION_STORAGE) !== null) {
                (0, storage_handler_1.clearSessionData)(constants_2.SESSION_STORAGE);
            }
            this.state.responseType = type;
        }
    }
    handleOpenAddToListDialog(event) {
        event.preventDefault();
        this.setState('showAddToListDialog', true);
    }
    handleCloseAddToListDialog() {
        this.setState('showAddToListDialog', false);
    }
    handleAddToListToast(open, content, isError) {
        this.setState({
            snackbar: {
                open,
                content,
            },
            isError,
        });
        const { pageId = '', eventFamily } = this.input.trackingData || {};
        const trackingData = {
            eventFamily: eventFamily || 'MYEBAY',
            eventAction: 'ACTN',
            actionKind: 'SHOWDIALOG',
            flushImmediately: false,
            pageId: `p${pageId}`,
            moduleId: 'm163180',
        };
        const { itemDetails } = this.state;
        const { itemData } = itemDetails || {};
        (0, tracking_handler_1.handleTracking)(trackingData, itemData, constants_1.WATCH_ACTION.ADD_ACTION);
    }
    handleOpenSkuSelector() {
        this.setState('showSkuSelector', true);
    }
    handleCloseSkuSelector() {
        this.setState('showSkuSelector', false);
    }
    handleSkuSelectorToast(open, content, isError) {
        this.setState({
            snackbar: {
                open,
                content,
            },
            isError,
        });
    }
    handleSkuSelectorDone(_event, selectedTraits) {
        this.handleCloseSkuSelector();
        this.handleWatchAction(selectedTraits === null || selectedTraits === void 0 ? void 0 : selectedTraits.variationId);
    }
}
exports.default = WatchHeartCTA;
